<template>
  <v-app id="app">
    <header>
      <v-app-bar dark app class="primary white--text"> <!-- hide-on-scroll  collapse-on-scroll-->
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <router-link to="/home">
          <v-img
            alt="Logo"
            class="shrink"
            contain
            src="@/assets/logo/A2_logo.png"
            transition="scale-transition"
            width="40"
          />
        </router-link>
        <router-link v-if="windowWidth > 530" to="/home">
          <v-img
            alt="Logo"
            class="shrink mt-2"
            contain
            src="@/assets/logo/name.png"
            transition="scale-transition"
            width="400"
          />
        </router-link>
        <router-link v-if="windowWidth <= 530" to="/home">
          <v-img
            alt="Logo"
            class="shrink mt-2"
            contain
            src="@/assets/logo/name.png"
            transition="scale-transition"
            width="270"
          />
        </router-link>
        <!-- <v-toolbar-title class="title" style="white-space: pre-line">徳島大学 高信頼マルチモーダル感性知能と知識工学研究室</v-toolbar-title> -->

        <v-spacer></v-spacer>

        <!-- <v-btn to="/login" light>
          ログイン
        </v-btn> -->

        <template v-if="windowWidth > 750" v-slot:extension>
          <v-tabs fixed-tabs center-active show-arrows>
            <template v-for="tab in tabs">
              <v-tab
                :key="tab.to"
                class="white--text"
                :to="tab.to"
                @click="selectTab(tab.to)"
              >
                <v-icon left color="white">{{ tab.icon }}</v-icon>
                {{ tab.label }}
              </v-tab>
            </template>
          </v-tabs>
        </template>
      </v-app-bar>

      <!-- ハンバーガーメニュー追加 --->
      <v-navigation-drawer
        v-model="drawer"
        fixed
        temporary
        width="300"
      >
        <v-container>
          <v-toolbar-title class="text-subtitle-1">
            <v-app-bar-nav-icon @click="drawer = false"></v-app-bar-nav-icon>
            <router-link to="/home">
              <v-img
                alt="Logo"
                class="shrink mr-4"
                contain
                src="@/assets/logo/A2_logo.png"
                transition="scale-transition"
                width="40"
                @click="drawer = false"
              ></v-img>
            </router-link>
          徳島大学 <br> 高信頼マルチモーダル感性知能と <br> 知識工学研究室</v-toolbar-title>
          <v-list dense flat>
            <template v-for="tab in tabs">
              <router-link class="routerLink" :to="tab.to" :key="tab.to">
                <v-list-item @click="drawer = false; selectTab(tab.to)">
                  <v-list-item-title :class="{ 'custom-color': selectedItem === tab.to }">
                    <v-icon left color="black">{{ tab.icon }}</v-icon>{{ tab.label }}
                  </v-list-item-title>
                </v-list-item>
              </router-link>
            </template>
          </v-list>
        </v-container>
      </v-navigation-drawer>
    </header>

    <v-main>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>

    <footer>
      <v-footer class="primary" padless>
        <v-row justify="center" no-gutters>
          <v-col
            cols="6"
            sm="3"
            align="center"
            v-for="content in contents"
            :key="content.name"
          >
            <v-btn
              :href="content.url"
              target="_blank"
              text
              rounded
              color="white"
              class="my-2"
            >
              {{ content.name }}
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-col>
          <v-col class="py-4 text-center white--text" cols="12">
            &copy; 2024 TMAK Lab. All Rights Reserved.
          </v-col>
        </v-row>
      </v-footer>
    </footer>
  </v-app>
</template>

<script>
import tablist from './components/data/tab_list'

export default {
  data() {
    return {
      contents: [
        { name: "徳島大学", url: "https://www.tokushima-u.ac.jp/" },
        { name: "徳島大学理工学部", url: "https://www.tokushima-u.ac.jp/st/" },
      ],
      drawer: false,
      tabs: tablist.tabs,
      windowWidth: window.innerWidth,
      selectedItem: '/home',
    };
  },
  mounted() {
   window.addEventListener('resize', this.calculateWindowWidth);
  },
  beforeDestroy() {
   window.removeEventListener('resize', this.calculateWindowWidth);
  },
  methods: {
    calculateWindowWidth() {
      this.windowWidth = window.innerWidth;
      console.log(this.windowWidth);
    },
    selectTab(tab) {
    this.selectedItem = tab; // 選択されたタブの情報を変数に代入
    },
  }
}
</script>

<style scoped>
#app {
  background: #fafafa;
}
.routerLink{
  text-decoration: none;
 }
 .custom-color {
  color: #002884;
}
</style>